/* eslint-disable @typescript-eslint/no-namespace */
import * as CubiqTS from "shared/cubiq-model-multi-asset";

export enum StaticDataPrivatizationType {
  None = 0,
  Private,
  BranchPrivate,
  Restricted,
  RestrictedClientSegment,
  RestrictedIdName,
}

export namespace StaticDataPrivatizationType {
  export function setPrivatization(model: any, type: StaticDataPrivatizationType): object {
    if (model instanceof CubiqTS.ConcreteEncodable) {
      model.extendedInfo.set("__bfx_privatization_type", StaticDataPrivatizationType[type]);
    } else {
      Object.defineProperty(model, "__bfx_privatization_type", {
        value: type,
      });
    }

    return model;
  }

  export function hasPrivatization(model: object | CubiqTS.ConcreteEncodable) {
    if (model instanceof CubiqTS.ConcreteEncodable) {
      if (model.extendedInfo.has("__bfx_privatization_type")) {
        let type = StaticDataPrivatizationType[model.extendedInfo.get("__bfx_privatization_type")];
        return type > StaticDataPrivatizationType.None;
      }
      return false;
    }

    if (model == null || typeof model != "object") return false;

    return (
      Object.prototype.hasOwnProperty.call(model, "__bfx_privatization_type") &&
      model["__bfx_privatization_type"] > StaticDataPrivatizationType.None
    );
  }

  export function isRestricted(model: object) {
    if (model instanceof CubiqTS.ConcreteEncodable) {
      if (model.extendedInfo.has("__bfx_privatization_type")) {
        let type = StaticDataPrivatizationType[model.extendedInfo.get("__bfx_privatization_type")];
        return (
          StaticDataPrivatizationType.Restricted === type ||
          StaticDataPrivatizationType.RestrictedClientSegment === type ||
          StaticDataPrivatizationType.RestrictedIdName === model["__bfx_privatization_type"]
        );
      }
      return false;
    }

    if (model == null || typeof model != "object") return false;

    return (
      (Object.prototype.hasOwnProperty.call(model, "__bfx_privatization_type") &&
        StaticDataPrivatizationType.Restricted === model["__bfx_privatization_type"]) ||
      StaticDataPrivatizationType.RestrictedClientSegment === model["__bfx_privatization_type"] ||
      StaticDataPrivatizationType.RestrictedIdName === model["__bfx_privatization_type"]
    );
  }

  export function isRestrictedIdName(model: object) {
    if (model instanceof CubiqTS.ConcreteEncodable) {
      if (model.extendedInfo.has("__bfx_privatization_type")) {
        let type = StaticDataPrivatizationType[model.extendedInfo.get("__bfx_privatization_type")];
        return StaticDataPrivatizationType.RestrictedIdName === type;
      }
      return false;
    }

    if (model == null || typeof model != "object") return false;

    return (
      Object.prototype.hasOwnProperty.call(model, "__bfx_privatization_type") &&
      StaticDataPrivatizationType.RestrictedIdName === model["__bfx_privatization_type"]
    );
  }

  export function isRestrictedClientSegment(model: object) {
    if (model instanceof CubiqTS.ConcreteEncodable) {
      if (model.extendedInfo.has("__bfx_privatization_type")) {
        let type = StaticDataPrivatizationType[model.extendedInfo.get("__bfx_privatization_type")];
        return StaticDataPrivatizationType.RestrictedClientSegment === type;
      }
      return false;
    }

    if (model == null || typeof model != "object") return false;

    return (
      Object.prototype.hasOwnProperty.call(model, "__bfx_privatization_type") &&
      StaticDataPrivatizationType.RestrictedClientSegment === model["__bfx_privatization_type"]
    );
  }

  export function isBranchPrivate(model: object) {
    if (model instanceof CubiqTS.ConcreteEncodable) {
      if (model.extendedInfo.has("__bfx_privatization_type")) {
        let type = StaticDataPrivatizationType[model.extendedInfo.get("__bfx_privatization_type")];
        return StaticDataPrivatizationType.BranchPrivate === type;
      }
      return false;
    }

    if (model == null || typeof model != "object") return false;

    return (
      Object.prototype.hasOwnProperty.call(model, "__bfx_privatization_type") &&
      StaticDataPrivatizationType.BranchPrivate === model["__bfx_privatization_type"]
    );
  }

  export function isPrivate(model: object) {
    if (model instanceof CubiqTS.ConcreteEncodable) {
      if (model.extendedInfo.has("__bfx_privatization_type")) {
        let type = StaticDataPrivatizationType[model.extendedInfo.get("__bfx_privatization_type")];
        return StaticDataPrivatizationType.Private === type;
      }
      return false;
    }

    if (model == null || typeof model != "object") return false;

    return (
      Object.prototype.hasOwnProperty.call(model, "__bfx_privatization_type") &&
      StaticDataPrivatizationType.Private === model["__bfx_privatization_type"]
    );
  }
}
